(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('StatsDailyController', StatsDailyController);

    StatsDailyController.$inject = ['DateUtils', 'StatsDaily', 'AlertService', 'StatsService', 'StatsActiveUserOS', 'StatsPerTime'];

    function StatsDailyController(DateUtils, StatsDaily, AlertService, StatsService, StatsActiveUserOS, StatsPerTime) {
        var vm = this;
        vm.search = search;
        vm.searchQuery = {
            fromDate: DateUtils.currentDate()
        };
        search();

        var options = {
            onSelectedDateChanged: function (event, date) {
                vm.searchQuery = {
                    fromDate: DateUtils.converterDateFormat(date),
                    client: vm.searchQuery.client
                };
            }
        };

        function search() {
            StatsDaily.query(vm.searchQuery, onSuccess, onError);
            StatsService.query(vm.searchQuery, onSuccessService, onError);
            StatsActiveUserOS.query(vm.searchQuery, onSuccessActiveUserOS, onError);
            StatsPerTime.query(vm.searchQuery, onSuccessTransactionPerTime, onError);

            function onSuccess(data, headers) {
                vm.stats = data;
            }

            function onSuccessService(data, headers) {
                makeServiceTypesPieChart(data);
            }

            function onSuccessActiveUserOS(data, headers) {
                makeActiveUserOSPieChart(data);
            }

            function onSuccessTransactionPerTime(data, headers) {
                makeTransactionPerTimeChart(data);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

        };

        $('#paginator').datepaginator(options);

        function makeServiceTypesPieChart(data) {
            var chart1 = AmCharts.makeChart("piechart1", {
                "type": "pie",
                "startDuration": 0,
                "theme": "light",
                "addClassNames": true,
                "legend": {
                    "position": "right",
                    "marginRight": 100,
                    "autoMargins": false
                },
                "innerRadius": "30%",
                "defs": {
                    "filter": [{
                        "id": "shadow",
                        "width": "200%",
                        "height": "200%",
                        "feOffset": {
                            "result": "offOut",
                            "in": "SourceAlpha",
                            "dx": 0,
                            "dy": 0
                        },
                        "feGaussianBlur": {
                            "result": "blurOut",
                            "in": "offOut",
                            "stdDeviation": 5
                        },
                        "feBlend": {
                            "in": "SourceGraphic",
                            "in2": "blurOut",
                            "mode": "normal"
                        }
                    }]
                },
                "dataProvider": data,
                "valueField": "amount",
                "titleField": "titleField",
                "export": {
                    "enabled": true
                }
            });

            chart1.addListener("init", handleInit);

            chart1.addListener("rollOverSlice", function (e) {
                handleRollOver(e);
            });
        }

        function handleInit() {
            chart1.legend.addListener("rollOverItem", handleRollOver);
        }

        function handleRollOver(e) {
            var wedge = e.dataItem.wedge.node;
            wedge.parentNode.appendChild(wedge);
        }


        function makeActiveUserOSPieChart(data) {
            var chart = AmCharts.makeChart("piechart2", {
                "type": "pie",
                "theme": "light",
                "dataProvider": data,
                "valueField": "numberOfUsers",
                "titleField": "OSType",
                "descriptionField": "description",
                "balloon": {
                    "fixedPosition": true
                },
                "export": {
                    "enabled": true
                },
                "radius": "100"
            });
        }

        function makeActiveUserMerchantPieChart(data) {
            var chart4 = AmCharts.makeChart("piechart3", {
                "type": "pie",
                "theme": "light",
                "dataProvider": data,
                "valueField": "numberOfUsers",
                "titleField": "MerchantType",
                "descriptionField": "description",
                "balloon": {
                    "fixedPosition": true
                },
                "export": {
                    "enabled": true
                },
                "radius": "100"
            });
        }

        function makeTransactionPerTimeChart(data) {
            var chart = AmCharts.makeChart("barchart", {
                "type": "serial",
                "addClassNames": true,
                "theme": "light",
                "autoMargins": false,
                "marginLeft": 30,
                "marginRight": 8,
                "marginTop": 10,
                "marginBottom": 26,
                "balloon": {
                    "adjustBorderColor": false,
                    "horizontalPadding": 10,
                    "verticalPadding": 8,
                    "color": "#ffffff"
                },

                "dataProvider": data,
                "valueAxes": [{
                    "axisAlpha": 0,
                    "position": "left"
                }],
                "startDuration": 1,
                "graphs": [{
                    "alphaField": "alpha",
                    "balloonText": "<span style='font-size:12px;'>[[title]] in [[category]]:<br><span style='font-size:20px;'>[[value]]</span> [[additional]]</span>",
                    "fillAlphas": 1,
                    "title": "Success",
                    "type": "column",
                    "valueField": "successes",
                    "dashLengthField": "dashLengthColumn"
                }, {
                    "id": "graph2",
                    "balloonText": "<span style='font-size:12px;'>[[title]] in [[category]]:<br><span style='font-size:20px;'>[[value]]</span> [[additional]]</span>",
                    "bullet": "round",
                    "lineThickness": 4,
                    "bulletSize": 20,
                    "bulletBorderAlpha": 4,
                    "bulletColor": "red",
                    "useLineColorForBulletBorder": false,
                    "bulletBorderThickness": 3,
                    "fillAlphas": 0,
                    "lineAlpha": 1,
                    "title": "Failure",
                    "valueField": "failures",
                    "dashLengthField": "dashLengthLine"
                }],
                "categoryField": "timeSlot",
                "categoryAxis": {
                    "gridPosition": "start",
                    "axisAlpha": 0,
                    "tickLength": 0
                },
                "export": {
                    "enabled": true
                }
            });
        }
    }
})();
